// Fuelin Landing Page - Scroll Animations
document.addEventListener('DOMContentLoaded', () => {
  // Scroll animations using Intersection Observer
  const animatedElements = document.querySelectorAll('.fuelin-animate-on-scroll');
  
  if (animatedElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(el => observer.observe(el));
  }

  // Flavor items animation
  const flavorItems = document.querySelectorAll('.fuelin-flavor-item');
  if (flavorItems.length > 0) {
    const flavorObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          flavorObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    });

    flavorItems.forEach(el => flavorObserver.observe(el));
  }
});

